import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  standalone: false,
  styleUrls: ['./date-filter.component.scss']
})
export class DateFilterComponent {

  @Input() fromDate: any;
  @Input() toDate: any;
  @Output() dateSelected = new EventEmitter<{ fromDate: any, toDate: any }>();

  placeHolder = 'DD/MM/YYYY';
  minStart: any;
  showClear = false;
  errorMessage: string = '';

  constructor(
    private _util: UtilService
  ) {

  }

  ngOnInit() {
  }

  private dateToTimestamp(dateObj: any): number | null {
    if (!dateObj) return null;
    if (typeof dateObj === 'number') return dateObj;
    if (dateObj instanceof Date) return dateObj.getTime();
    if (dateObj.year && dateObj.month && dateObj.day) {
      return new Date(dateObj.year, dateObj.month - 1, dateObj.day).getTime();
    }
    const ts = Date.parse(dateObj);
    return isNaN(ts) ? null : ts;
  }

  private validateDates(): boolean {
    this.errorMessage = '';
    if (!this.fromDate && !this.toDate) return true;
    if (!this.fromDate || !this.toDate) {
      this.errorMessage = 'Both From Date and To Date are required';
      return false;
    }
    const fromTs = this.dateToTimestamp(this.fromDate);
    const toTs = this.dateToTimestamp(this.toDate);
    if (fromTs === null || toTs === null) {
      this.errorMessage = 'Invalid date format';
      return false;
    }
    if (toTs < fromTs) {
      this.errorMessage = 'To Date must not be earlier than From Date';
      return false;
    }
    return true;
  }

  onClear() {
    const vm = this;
    vm.fromDate = null;
    vm.toDate = null;
    vm.showClear = false;
    vm.errorMessage = '';
    vm.dateSelected.emit({ fromDate: null, toDate: null });
  }

  onFromDate(event: any) {
    const vm = this;
    vm.minStart = vm._util.getMinFormat(event);
  }

  onSubmit() {
    const vm = this;
    if (!vm.validateDates()) return;
    vm.errorMessage = '';
    const fromTs = vm.dateToTimestamp(vm.fromDate);
    const toTs = vm.dateToTimestamp(vm.toDate);
    vm.showClear = true;
    vm.dateSelected.emit({ fromDate: fromTs, toDate: toTs });
  }

}
